<template lang="pug">
    //CrudForm(
        v-bind="staticData"
        :fields="myFields"
            :customRules="customRules"
            @submitForm="handleSubmit($event)"
        )
    model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="crear etiqueta"
        :fields="fields"
        v-model="formData"
        @reset="resetForm"
        @submit="handleSubmit"
        )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import CommuneService from '@/services/api/commune/CommuneService'
import TagService from '@/services/api/tag/TagServices'
//-
import MdlTag from '../../models/Warehouse/WhTag'
import FieldsCreate from './FieldsCreate'
//-
import { mapActions } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            formData: {},
            fields: FieldsCreate,
        }
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        resetForm() {
            this.formData = {}
        },
        async handleSubmit(data) {
            new MdlTag(data)
                .save()
                .then(this.handleResponse)
                .catch(this.showErrorSnackbar)
        },
        handleResponse(response) {
            //
            if (response.status === 'success')
                return this.showSuccessSnackbar(
                    this.$router.push({ path: '/tags' })
                )
            //
            return this.showErrorSnackbar(response)
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response.error, false, 3000)
            )
        },
        showSuccessSnackbar() {
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Etiqueta creada exitosamente.',
                    false,
                    3000
                )
            )
        },
    },
    watch: {},
    components: { ModelForm },
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeMount: async function() {
        this.setTitleTopBar('Crear etiqueta')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PRODUCT_TAG')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
